import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/history/tas_program_instance_version_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Mirrors
// tas-program-template-version.schema.ts; the existing `version` trait supplies
// itemType/event/objectChanges/createdAt/changelog/whodunnit, and the resource
// declares no belongsTo/hasMany so there are no relationship fields.
const TasProgramInstanceVersionSchema = withDefaults({
  type: 'tas-program-instance-version',
  traits: ['version'],
  fields: [],
});

export default TasProgramInstanceVersionSchema;
